// index
export const GET_USER_DATA = "GET_USER_DATA";
export const UPDATE_USER_DATA = "UPDATE_USER_DATA";
export const GET_USER_TARIFF = "GET_USER_TARIFF";

// contacts
export const LINK_ACCOUNT = "LINK_ACCOUNT";
export const UNLINK_ACCOUNT = "UNLINK_ACCOUNT";
export const SEND_REQUEST_CHANGE_CONTACTS = "SEND_REQUEST_CHANGE_CONTACTS";
export const SEND_REQUEST_CHANGE_CONTACTS_EMAIL = "SEND_REQUEST_CHANGE_CONTACTS_EMAIL";
export const SEND_REQUEST_CHANGE_CONTACTS_PHONE = "SEND_REQUEST_CHANGE_CONTACTS_PHONE";

// password
export const PASSWORD_UPDATE = "PASSWORD_UPDATE";

// setting
export const SETTING_GET_LANGUAGE_INTERFACE = "SETTING_GET_LANGUAGE_INTERFACE";
export const SETTING_GET_FORMATS_DATE = "SETTING_GET_FORMATS_DATE";
export const SETTING_GET_BASIC_COUNTRIES = "SETTING_GET_BASIC_COUNTRIES";
export const SETTING_UPDATE = "SETTING_UPDATE";

// main-info
export const INFO_GET_GENDERS_LIST = "INFO_GET_GENDERS_LIST";
export const INFO_GET_USER_FULLNAME = "INFO_GET_USER_FULLNAME";
export const INFO_GET_USER_BIRTHDAY = "INFO_GET_USER_BIRTHDAY";
export const INFO_UPDATE = "INFO_UPDATE";
export const GET_USER_SKILLS = "GET_USER_SKILLS";
export const UPDATE_AVATAR = "UPDATE_AVATAR";

// tariffs
export const GET_USER_FREE_ACCESS = "GET_USER_FREE_ACCESS";
export const DELETE_USER_TARIFF = "DELETE_USER_TARIFF";
export const UPDATE_USER_TARIFF = "UPDATE_USER_TARIFF";
export const PAYMENT_USER_TARIFF = "PAYMENT_USER_TARIFF";

// payments
export const GET_CARDS_LIST = "GET_CARDS_LIST";
export const SET_NEW_PAYMENTS_METHOD = "SET_NEW_PAYMENTS_METHOD";
export const REPLACE_PAYMENTS_METHOD = "REPLACE_PAYMENTS_METHOD";
export const SET_DEFAULT_PAYMENT_METHOD = "SET_DEFAULT_PAYMENT_METHOD";
export const DELETE_CARD = "DELETE_CARD";

// payments-history
export const GET_LIST = "GET_LIST";

// homework
export const GET_USER_HOMEWORK = "GET_USER_HOMEWORK";
export const GET_STATUS_LIST = "GET_STATUS_LIST";
